import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req } from '@nestjs/common';
import { ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { ConfCallService } from './conf-call.service';
import { ConfCallDTO, PaginationDto } from './dto/conf-call.dto';
import { ConfCollResponseModel, AllConfCollResponseModel } from './dto/conf-call-response-module';

@ApiTags('ConfCall')
@Controller('confcall')
export class ConfCallController {
    constructor (
        private ccserv:ConfCallService
    ) {}

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createCall')
    @ApiQuery({name:'apiVersion'})
    async createCall(@Query() queryParams, @Body() ConfCallDTO:ConfCallDTO, @Req() request: Request): Promise<ConfCollResponseModel> {
        try {
            return await this.ccserv.createCall(queryParams, ConfCallDTO, request);
        } catch (error) {
            return errorHandler(ConfCollResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getCalls')
    @ApiQuery({name:'apiVersion'})   
    async getCalls(@Query()pageDto:PaginationDto,@Req()request: Request): Promise<AllConfCollResponseModel> {
        try {
            return await this.ccserv.getCalls(pageDto, request);
        } catch (error) {
            return errorHandler(AllConfCollResponseModel, error);
      
        }
    }

    
}
